/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import { IconType } from "react-icons/lib";
import ReactTooltip from "react-tooltip";

interface ActionButtonProps {
  icon: IconType | JSX.Element;
  backgroundColor: string;
  tooltipLabel: string;
  onClick: () => void;
}

interface ActionButtonWrapperProps {
  backgroundColor: string;
  justIcon?: boolean;
}

const TooltipText = styled.span`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #ffffff;
`;

function hr(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

export const ActionButtonWrapper = styled.div<ActionButtonWrapperProps>`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${(props) => props.backgroundColor};
  box-shadow: 0 5px 10px
    rgb(
      ${(props) =>
        `${hr(props.backgroundColor)?.r},${hr(props.backgroundColor)?.g}, ${
          hr(props.backgroundColor)?.b
        },0.5 `}
    );
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  > svg {
    width: 20px;
    height: 20px;

    fill: #fff;
  }
  ${(props) =>
    !props.justIcon &&
    `&:hover {
    transform: scale(1.125);
    box-shadow: 0px 5px 15px ${(props: ActionButtonWrapperProps) =>
      props.backgroundColor};
  }`}
`;

export default function ActionButton({
  icon,
  backgroundColor,
  tooltipLabel,
  onClick,
}: ActionButtonProps) {
  return (
    <>
      <ActionButtonWrapper
        data-tip
        data-for={tooltipLabel}
        onClick={onClick}
        backgroundColor={backgroundColor}
      >
        {icon}
      </ActionButtonWrapper>
      <ReactTooltip
        backgroundColor="white"
        css={css`
          box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);

          span {
            color: black;
          }
        `}
        id={tooltipLabel}
        place="right"
        effect="solid"
      >
        <TooltipText>{tooltipLabel}</TooltipText>
      </ReactTooltip>
    </>
  );
}
